import React, { useState } from 'react'

import KenFormCard from '../KenFormCard';


import SampleFormConfig from './form.json';
import { Grid } from '@material-ui/core';
import KenInputField from '../KenInputField';
import KenSelect from '../KenSelect';
import KenRadioGroup from '../KenRadioGroup';
import KenCheckbox from '../KenCheckbox';
import KenTextArea from '../KenTextArea';
import KenToggleButton from '../KenToggleButton';
import KenFormStepper from '../KenFormStepper';
import StepperFooter from '../../pages/StepperFooter';
import { useFormik } from 'formik';



export const useKenFormStepper = () => {

    const [activeStep, setActiveStep] = useState(0);
    const handleNext = () => {
        setActiveStep(activeStep + 1)
    };
    const handleBack = () => setActiveStep(activeStep - 1);

    return { activeStep, setActiveStep, handleNext, handleBack };
}


export default function KenFormBuilder(props) {

    const { FormConfig = SampleFormConfig,
        formSubmits = [],
        activeStep,
        setActiveStep,
        handleNext,
        handleBack } = props;

    const defaultFormData = {};
    const [formData, setFormData] = useState(defaultFormData);

    const steps = FormConfig.sort((a, b) => a.stepNumber - b.stepNumber)

    return (
        <div>
            <StepperBuilder
                steps={steps}
                {...{
                    activeStep,
                    setActiveStep,
                    handleNext,
                    handleBack
                }}
                formData={formData}
                formSubmits={formSubmits} />
        </div>
    )
}

const StepperBuilder = ({ steps = [], activeStep, handleBack, handleNext, stepsCount, formSubmits }) => {

    const stepperConfig = { activeStep, handleBack, handleNext, stepsCount, formSubmits };

    return (
        <>
            <Grid container>
                <Grid item xs={2}>
                    <KenFormStepper steps={steps} activeStep={activeStep} />
                </Grid>
                <Grid item xs={10}>
                    <StepContent {...steps[activeStep]} {...stepperConfig} />
                </Grid>
            </Grid>
            {/* <StepContent {...step} /> */}
        </>
    )

}


const StepContent = ({ sections = [], handleBack, handleNext, activeStep, stepsCount, formSubmits }) => {


    const formik = useFormik({
        initialValues: {
        },
        onSubmit: formSubmits[activeStep],
    });

    const { handleChange,
        handleSubmit,
        setFieldTouched,
        setFieldValue,
        values
    } = formik;
    return (
        <>
            <form onSubmit={handleSubmit}>
                {sections.map(section => (section.sectionVisible &&
                    <>
                        <SectionBuilder {...section}
                            handleChange={handleChange}
                            setFieldTouched={setFieldTouched}
                            setFieldValue={setFieldValue}
                            values={values}
                        />
                    </>
                ))}
                {/* Footer with next and previous */}
                <StepperFooter
                    stepperHandleBack={handleBack}
                    stepperActiveStep={activeStep}
                    handleSubmit={handleSubmit}
                    stepsCount={stepsCount}
                />
            </form>
        </>
    )
}



const SectionBuilder = ({ sectionName,
    sectionHelp,
    fields = [],
    handleChange,
    setFieldTouched,
    setFieldValue,
    values }) => {


    fields.forEach(f => f['name'] = f['name'] || f['label']);

    return (
        <>
            <KenFormCard title={sectionName} helpText={sectionHelp}>
                {fields && fields.length > 0 &&
                    <>
                        <Grid container spacing={5}>

                            {fields.map(field =>
                                <WidgetBuilder {...field}
                                    handleChange={handleChange}
                                    setFieldTouched={setFieldTouched}
                                    setFieldValue={setFieldValue}
                                    value={values[field.name]}
                                />
                            )}
                        </Grid>
                    </>
                }
            </KenFormCard>
        </>
    )
}

const ALLOWED_TYPES = [
    'text', 'select', 'checkbox', 'radio', 'textarea', 'toggle',
    'range', 'time', 'date', 'datetime-local', 'week', 'month',
    'password', 'url', 'color',
    'text', 'email', 'number', 'search', 'tel'
]

const WidgetBuilder = (props) => {
    const { type, ui: { grid: { xs = 12, sm = 6, md = 4, lg = 4 } } = {} } = props;

    // valide if type allowed 

    return (
        <>
            {type && ALLOWED_TYPES.includes(type.toLowerCase()) &&
                <Grid item xs={xs} sm={sm} md={md} lg={lg}>
                    <Widget  {...props} type={type.toLowerCase()} />
                </Grid>
            }
        </>
    )
}

// Type of element and component mapping
const Widget = (props) => {

    const {
        type,
        name,
        label,
        placeholder,
        options,
        handleChange,
        setFieldTouched,
        setFieldValue,
        value
    } = props;

    const change = (name, e, index) => {
        e.persist();
        handleChange(e);
        setFieldTouched(name, true, false);
    };

    // Types handle:  'select','checkbox','radio','textarea','toggle',
    //      'range','time','date','datetime-local','week'
    //   deafults to input : 'text','email','number','search','tel',
    const defaultProps = {
        type,
        label,
        name: name || label,
        placeholder,
        options,
        handleChange,
        onChange: change.bind(null, name),
        value
    }

    switch (type) {

        case 'select':
            return <KenSelect {...defaultProps} />;

        case 'checkbox':
            return <KenCheckbox {...defaultProps} />

        case 'radio':
            return <KenRadioGroup {...defaultProps} />

        case 'textarea':
            return <KenTextArea {...defaultProps} />

        case 'toggle':
            const onToggleChange = (newValue) => {
                setFieldTouched(name);
                setFieldValue(name, newValue);
            };
            return <KenToggleButton {...defaultProps} onChange={onToggleChange} />

        default:
            return <KenInputField {...defaultProps} />

    }
}
